import type { PreparedBarometerAuction } from '@autobid/ui/types/components/AuctionsData'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { AUCTION_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useAuctionSocket'
import { singleAuctionQueryKey } from '@autobid/ui/composables/useAuction'
import { useQueryClient } from '@tanstack/vue-query'

export function useAuctionAuctionResume() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const auctionResume = () => {
    startListen({
      eventName: 'premium.AUCTION_RESUME',
      callbackName: AUCTION_SOCKET_CALLBACK,
      callback: (event) => {
        const auctionKey = singleAuctionQueryKey.byAuctionId(event.context.auctionId)

        queryClient.setQueriesData(auctionKey, (data?: PreparedBarometerAuction) => {
          if (!data) {
            return data
          }

          return {
            ...data,
            isPaused: false,
            pauseDate: null,
          }
        })
      },
    })
  }

  return { auctionResume }
}
